import { Table } from '@factorialco/deprecated-design-system'
import type { JustifyContent } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface HeaderName {
  name: string
  colSpan: number
  attribute: string
  justifyContent: JustifyContent
}

const Header = () => {
  const headerNames: HeaderName[] = [
    {
      name: '',
      colSpan: 2,
      attribute: 'phase',
      justifyContent: 'flexStart',
    },
    {
      name: i18n.t('finance.quotes.quote_phases_table.headers.hours_units'),
      colSpan: 2,
      attribute: 'hours',
      justifyContent: 'flexStart',
    },
    {
      name: i18n.t('finance.quotes.quote_phases_table.headers.cost_per_unit'),
      colSpan: 2,
      attribute: 'cost',
      justifyContent: 'flexEnd',
    },
    {
      name: i18n.t('finance.quotes.quote_phases_table.headers.bill_per_unit'),
      colSpan: 2,
      attribute: 'bill',
      justifyContent: 'flexEnd',
    },
    {
      name: i18n.t('finance.quotes.quote_phases_table.headers.profit'),
      colSpan: 2,
      attribute: 'profit',
      justifyContent: 'flexEnd',
    },
    {
      name: i18n.t('finance.quotes.quote_phases_table.headers.total_cost'),
      colSpan: 2,
      attribute: 'total_cost',
      justifyContent: 'flexEnd',
    },
    {
      name: i18n.t('finance.quotes.quote_phases_table.headers.total_to_bill'),
      colSpan: 2,
      attribute: 'total_bill',
      justifyContent: 'flexEnd',
    },
    {
      name: '',
      colSpan: 1,
      attribute: 'actions',
      justifyContent: 'center',
    },
  ]

  return (
    <Table.Head>
      <Table.Row>
        {headerNames.map((headerName) => (
          <Table.HeadCell
            justifyContent={headerName.justifyContent}
            key={headerName.attribute}
            colSpan={headerName.colSpan}
          >
            {headerName.name}
          </Table.HeadCell>
        ))}
      </Table.Row>
    </Table.Head>
  )
}

export default Header
